// extracted by mini-css-extract-plugin
module.exports = {"sellers":"_02712f2b3b--sellers--GyCmn","sellers-list":"_02712f2b3b--sellers-list--KGgBP"};